import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

const UserAvatar = (props: Omit<FontAwesomeIconProps, 'icon'>) => {
  return <FontAwesomeIcon size="3x" color="#2862ff" {...props} icon={faUserCircle} />;
};

export { UserAvatar };
